import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

export default (WrappedComponent, ref) => props => {
  const [cur, setCur] = useState(null);
  useEffect(() => {
    if (ref.current) {
      setCur(ref.current);
    }
  }, []);
  return cur
    ? ReactDOM.createPortal(<WrappedComponent {...props} />, cur)
    : null;
};
